export enum Role {
  admin = 1,
  tehnolog = 2,
  prodavac = 3,
  sefProizvodnje = 4,
  radnik = 5
}
